import React, { useState } from "react"; 
import AdminHOC from "../../../components/shared/HOC/AdminHOC";
import useContentReport from "../../../hooks/CoursesHooks/useContenrReport";
import { useNavigate, useParams } from "react-router-dom";
import CommonTable from "../../../components/shared/table/Table";
import { contentReportColumns } from "../../../assets/constants/admin/courseContent";
import CustomInput from "../../../components/global/CustomInput/CustomInput";
import CustomButton from "../../../components/global/Button/CustomButton";
import CustomTab from "../../../components/shared/tab/TabComponent";
import { downloadContentReport } from "../../../service/AdminService/courseService";
import LottieIcon from "../../../components/shared/lottieIcon/LottieIcon";
import searchIcomsvg from "../../../assets/icons/Search-Icon.svg";
import Back from "../../../assets/back-btn.svg";
import { TAB_OPTIONS, } from "../../../assets/constants/constants";


const ContentReport = () => {
  const [isSearchHovered, setIsSearchHovered] = useState(false);
  const { contentId } = useParams();
  const navigate = useNavigate();



  const {
    data,
    loading,
    searchText,
    handleSearch,
    handleContentActiveChange,
    isContentActive,
    paginationConfig,
    handlePageChange,
    title,
  } = useContentReport(contentId);

  const handleDownload = async () => {
    const params = {
      search: searchText,
      isContentActive: isContentActive,
      page: paginationConfig?.current,
      limit: paginationConfig?.pageSize,
    };

    await downloadContentReport(contentId, params);
  };
  return (
    <div className="p-6 flex flex-col   border border-[#E8E8E8] rounded-[10px] shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)]">
      <div className="flex justify-between">
      <p className="text-[#E74860] text-[1.75rem] font-normal">
        Report for {title}
      </p>

      <div
        className="flex gap-2 justify-center cursor-pointer items-center"
        onClick={() => navigate(-1)}
      >
        <img alt="back-btn" src={Back} />
        <span>Back</span>
      </div>
      </div>

      <div className="flex justify-between mt-6">
        <CustomTab onChange={handleContentActiveChange} entries={TAB_OPTIONS} />
        <div className="flex gap-2">
          <div
            onMouseEnter={() => setIsSearchHovered(true)}
            onMouseLeave={() => setIsSearchHovered(false)}
          >
            <CustomInput
              icon={
                isSearchHovered ? (
                  <LottieIcon name="searchIcon" size={20} shouldPlay={true} />
                ) : (
                  <img src={searchIcomsvg} alt="search" className="w-5 h-5" />
                )
              }
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Search"
            />
          </div>
          <CustomButton onClick={handleDownload}>Export</CustomButton>
        </div>
      </div>

      <CommonTable
        columns={contentReportColumns}
        onChange={handlePageChange}
        data={data}
        showLoader={loading}
        loading={loading}
        pagination={paginationConfig}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default AdminHOC(ContentReport);
